import { render, staticRenderFns } from "./AddHub.vue?vue&type=template&id=b0b106d8"
import script from "./AddHub.vue?vue&type=script&lang=js"
export * from "./AddHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports